<template>
  <b-list-group-item class="sub-category-item">
    <p class="title">{{ title }}</p>
    <div class="d-flex align-items-center">
      <font-awesome-icon @click="handleEdit" icon="fa-solid fa-pen" class="mr-1 mr-sm-2 mr-md-3 badge" />
      <font-awesome-icon @click="handleDelete" icon="fa-solid fa-trash-can" class="badge delete" />
    </div>
  </b-list-group-item>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true }
  },
  methods: {
    handleDelete() {
      this.$emit('delete-category', { _id: this.id, title: this.title })
    },
    handleEdit() {
      this.$emit('edit-category', { _id: this.id, title: this.title })
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-category-item {
  height: 80px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  padding: 24px;
  font-size: 24px;
  color: #636e72;
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
}

.title {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
}

.badge {
  cursor: pointer;
  font-size: 16px;
  padding: 0;
}

.badge.delete {
  color: #ba3b46;
}
.badge.main {
  display: none;
}

@media screen and (min-width: 1200px) {
  .title {
    font-size: 24px;
  }
  .badge {
    font-size: 24px;
  }
}
</style>
